import { BankAccount } from '../../store/bank-accounts/interfaces';

export const needInternationalWireDetails = (country: string, bankCode?: string) => {
  const bankCodesList = [18, 66, 142, 143, 145, 147, 148, 150, 151, 152];
  return country === 'US' && bankCode && bankCodesList.includes(parseInt(bankCode));
};

export const USD_SETTLEMENTS_COUNTRIES = ['UY', 'PE', 'CR', 'PY', 'DO'];

export const supportsUsdSettlementsCountry = (country: string) => USD_SETTLEMENTS_COUNTRIES.includes(country);

export const isUsdSettlementBankAccount = (account: Pick<BankAccount, 'currency' | 'country'>) =>
  account.currency === 'USD' && supportsUsdSettlementsCountry(account.country);
